import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AunthLogin = ({ children }: any) => {
    const [auth, setAuth] = useState({});
    // let user_ = localStorage.getItem("token");
    return (
        <AuthContext.Provider value={{ auth, setAuth }}>     
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;